type MihatoMarkProps = {
  className?: string;
  /** Cuando es true, el pixel superior derecho se pinta con el emerald del light theme
   * (`app-emerald #0E8F6B`) — exclusivo del chrome del app (dashboard, rutas protegidas). */
  accent?: boolean;
};

/**
 * Logo voxel de Mihato (2 ojos, boca, mentón).
 * - Default: todos los rects heredan `currentColor`.
 * - `accent`: el pixel superior derecho se fija en `app-emerald`
 *   (calibrado para contraste AA sobre fondos claros del dashboard).
 */
export function MihatoMark({ className, accent = false }: MihatoMarkProps) {
  return (
    <svg
      className={className}
      viewBox="4 4 16 16"
      fill="currentColor"
      aria-label="Mihato"
      role="img"
    >
      <title>Mihato</title>
      <rect x="4" y="6" width="4" height="4" rx="0.5" />
      <rect
        x="16"
        y="6"
        width="4"
        height="4"
        rx="0.5"
        fill={accent ? "var(--color-app-emerald)" : undefined}
      />
      <rect x="8" y="10" width="8" height="4" />
      <rect x="10" y="13" width="4" height="5" rx="0.5" />
    </svg>
  );
}
